import { GridFilterItem, GridFilterOperator } from '@mui/x-data-grid';

import { SLASH_FULL_DATE_FORMAT } from 'core/constants';

import { createFilterRegex } from 'utils/regex';
import { formatFloating } from 'utils/formatters/timezone';
import { DatePickerRange, dateRangePickerValue } from './DateRangePicker';
import { DatePicker } from './DatePicker';
import EmptyNotEmpty from '../EmptyNotEmpty';

export const RangeOperators = (): GridFilterOperator[] =>
  [
    {
      label: 'range',
      value: 'range',
      getApplyFilterFn: (filterItem: GridFilterItem) => {
        if (!filterItem.value) {
          return null;
        }

        const filterRegex = createFilterRegex(filterItem.value);
        return ({ value }: { value: string }): boolean => (value != null ? filterRegex.test(value.toString()) : false);
      },
      InputComponent: DatePickerRange,
      InputComponentProps: { value: null },
      getValueAsString: (value: [number, number]) => dateRangePickerValue(value),
    },
  ] as unknown as GridFilterOperator[];

const BasicDateOperators = (): GridFilterOperator[] =>
  [
    {
      label: 'is',
      value: 'is',
      getApplyFilterFn: (filterItem: GridFilterItem) => {
        if (!filterItem.value) {
          return null;
        }
        const filterRegex = createFilterRegex(filterItem.value);
        return ({ value }: { value: string }): boolean => (value != null ? filterRegex.test(value.toString()) : false);
      },
      InputComponent: DatePicker,
      InputComponentProps: { value: null },
      getValueAsString: (value: number) => formatFloating(value, 'date', SLASH_FULL_DATE_FORMAT),
    },
    {
      label: 'range',
      value: 'range',
      getApplyFilterFn: (filterItem: GridFilterItem) => {
        if (!filterItem.value) {
          return null;
        }

        const filterRegex = createFilterRegex(filterItem.value);
        return ({ value }: { value: string }): boolean => (value != null ? filterRegex.test(value.toString()) : false);
      },
      InputComponent: DatePickerRange,
      InputComponentProps: { value: null },
      getValueAsString: (value: [number, number]) => dateRangePickerValue(value),
    },
  ] as unknown as GridFilterOperator[];

export default BasicDateOperators;

export const ExtendedDateOperators = (): GridFilterOperator[] =>
  [...BasicDateOperators(), ...EmptyNotEmpty()] as unknown as GridFilterOperator[];
